import { render, staticRenderFns } from "./ShowMatchesButton.vue?vue&type=template&id=153aa4a7&scoped=true&"
import script from "./ShowMatchesButton.vue?vue&type=script&lang=js&"
export * from "./ShowMatchesButton.vue?vue&type=script&lang=js&"
import style0 from "./ShowMatchesButton.vue?vue&type=style&index=0&id=153aa4a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153aa4a7",
  null
  
)

export default component.exports